

function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=go-cart");
  const text = await res.text();
  const html = document.createElement("div");
  // console.log(res,text,html)
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;

  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
}

function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();
        

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });



   document
    .querySelectorAll(".cart-drawer-quantity-selector input")
    .forEach((button) => {
      button.addEventListener("change", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart_inputt"
        );
        const newQuantity = currentQuantity;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();
        

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });



  
   document
    .querySelectorAll(".cart-drawer-quantity-selector .cart-remove-button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement
            .parentElement;
        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-remove-button"
        );
        const newQuantity = 0;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();
        

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });





  

  

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {
        // console.log("closing drawer");
        closeCartDrawer();
      });
    });
}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"],[name="add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // Submit form with ajax
    await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();

    // Open cart drawer
    openCartDrawer();
  });
});

document.querySelectorAll('a[aria-label="Cart"],[aria-label="Cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});


 // var isLoaded211=false;
 //          var _intv = setInterval(function(){
 //            if($('.cart-drawer').hasClass('cart-drawer--active') && isLoaded211==false){
 //              isLoaded211=true;
 //                // console.log("open")
 //              if($('.announcement-hidden').length > 0){
 //                  setTimeout(function(){
 //                  $('.cart-drawer.cart-drawer--active').attr('style','height: 91%;top: 9%;')
 //                  },500)
 //              }else{
 //                setTimeout(function(){
 //                $('.cart-drawer.cart-drawer--active').attr('style','height: 85%;top: 17%;')
 //                },500)
 //              }
 //            }
 //            else if(!$('.cart-drawer').hasClass('cart-drawer--active') && isLoaded211==true){
 //              isLoaded211=false;
 //             // console.log("close")
 //            }
 //          },500);



   $(document).on('click', '.carticons', function () {
// console.log('aaaaaaaaaaaaa')
   setTimeout(function(){
      document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
   },500)
 })

// $('.carticons').hover(function () {  
//   console.log('hiver')
//      document.querySelector(".cart-drawer").classList.add("cart-drawer--active");

//     return false;
// });

// $('body').hover(function(e) {
//   if (!$(e.target).is('.cart-drawer')) {
//   console.log('leave')
//   document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
//     return false;
//   }
// });


// $(document).ready(function () {
//   $('.carticons').hover(function () {
//    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
//   });

//   $('body').hover(function(e) {
//     if (!$(e.target).is('.cart-drawer')) {
//        document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
//     }
//   });
// });








//   $('.HorizontalList__Item.bbb').on('click',function(){
//     var colorlink = $(this).find('.colooor').attr('href');
//     console.log(colorlink)
//     if(colorlink != "" && colorlink != "undefined" && colorlink != null ){
//     window.location.replace(colorlink)
//     }
// })

// {% assign urlll = canonical_url | split: '/products/' | first %}